import VnNodeIcon from '@material-ui/icons/Computer';
import VnNodeList from './VnNodeList';
import VnNodeShow from './VnNodeShow';

export default {
    list: VnNodeList,
    icon: VnNodeIcon,
    show: VnNodeShow,
};